import { render } from "./UpdateCollabForm.vue?vue&type=template&id=6d430e3a"
import script from "./UpdateCollabForm.vue?vue&type=script&lang=js"
export * from "./UpdateCollabForm.vue?vue&type=script&lang=js"

import "./UpdateCollabForm.vue?vue&type=style&index=0&id=6d430e3a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__